import * as types from './mutation-types'
import Vue from 'vue'
import state from './state'

export default {
  telephone_input({ commit }) {
    commit('TELEPHONE_INPUT')
  },
  //获取详细定位
  getCurrentPosition({ commit, state }, that) {
    setTimeout(() => {
        if(that.platform == 'wx'){
            that.wx.ready((res) => {
                that.wx.getLocation({
                    success: function (res) {
                        let latlng = {
                        latitude: res.latitude,
                        longitude: res.longitude
                      }
                      commit('SET_POSITION', latlng)
                    },
                    cancel: function (res) {
                        alert('用户拒绝授权获取地理位置')
                    }
                })
            })
        }else{
            navigator.geolocation.getCurrentPosition((position) => {
              let latlng = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              };
              commit('SET_POSITION', latlng)
            }, (geo_error) => {})
        }
      },
      500)
    /*AMap.plugin(['AMap.Geolocation', 'AMap.Autocomplete'], function () {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,//是否使用高精度定位，默认:true
        timeout: 10000,          //超过10秒后停止定位，默认：无穷大
        maximumAge: 0,           //定位结果缓存0毫秒，默认：0
        convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        showButton: true,        //显示定位按钮，默认：true
        buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: true,     //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        extensions: 'all'
      });
      geolocation.getCurrentPosition(function (status, result) {
        // console.log(result)
        if(result.aois && result.aois.length>0 ){
          console.log(result)
          commit('SET_POSITION', result)
           map.addControl(geolocation);
        }else {
          if (state.hasLocation) {
            // console.log(123)
            return false
          } else {
            state.ismask = true
            state.location = true
            state.hasLocation = true
          }
        }
      }) 
    })*/
  },
}
